import React from "react";

import {
  Table,
  TableBody,
  TableHeader,
  TableRow,
  Td,
  Th,
} from "@graffer-inc/console-design-kit";
import { KintoneExportSetting } from "@graffer-inc/cloud-gov-core";

type Props = {
  kintoneExportSettings: Pick<
    KintoneExportSetting,
    "id" | "name" | "formResourceId" | "disabled"
  >[];
  onRowClick: (id: string) => void;
};

export const KintoneExportSettingsListTable: React.FC<Props> = ({
  kintoneExportSettings,
  onRowClick,
}) => {
  return (
    <Table>
      <TableHeader>
        <TableRow>
          <Th>ID</Th>
          <Th>名称</Th>
          <Th>手続き ID</Th>
          <Th>有効/無効</Th>
        </TableRow>
      </TableHeader>
      <TableBody>
        {kintoneExportSettings.map(({ id, name, formResourceId, disabled }) => {
          return (
            <TableRow
              key={id}
              onClick={() => {
                onRowClick(id);
              }}
            >
              <Td>{id}</Td>
              <Td>{name}</Td>
              <Td>{formResourceId} </Td>
              <Td>{disabled ? "無効" : "有効"}</Td>
            </TableRow>
          );
        })}
      </TableBody>
    </Table>
  );
};
